import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import { getWechatAppidByDomain } from '@/api/basic';
import { checkBrowserEnv } from '@/utils/utils';

/**
 * 融资企业报告独立路由。
 */
export const financingReportRouters: RouteRecordRaw[] = [
  {
    path: '/financingQuery',
    name: 'FinancingQuery',
    component: () => import('@/pages/h5/Report/FinancingQuery/index.vue'),
    meta: {
      title: '融资企业报告',
      // App 会在地址中追加 platform，内嵌页面由 App 自身提供顶部导航。
      // 全局容器会把函数返回值直接作为导航栏是否显示，因此外部 H5 返回 true。
      disabledNavBar: (route: RouteLocationNormalized) =>
        !['android', 'ios'].includes(String(route.query.platform || '').toLowerCase()),
    },
    beforeEnter: async (to, from, next) => {
      if (!to.query.code && checkBrowserEnv('wechat')) {
        try {
          const result = await getWechatAppidByDomain({ domain: location.host });
          if (result?.appid) {
            const redirectUri = encodeURIComponent(location.href);
            location.replace(
              `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${result.appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base#wechat_redirect`
            );
            return;
          }
        } catch (error) {
          console.error('融资企业报告微信授权获取应用编号失败', error);
        }
      }
      next();
    },
  },
  {
    path: '/financingReport',
    name: 'FinancingReport',
    component: () => import('@/pages/h5/Report/FinancingReport/index.vue'),
    redirect: '/financingEnterprise',
    children: [
      {
        path: '/financingEnterprise',
        name: 'FinancingEnterprise',
        component: () => import('@/pages/h5/Report/FinancingReport/Enterprise/index.vue'),
      },
    ],
    meta: { title: '融资企业报告', checkAuth: true },
  },
  {
    path: '/financingReportState',
    name: 'FinancingReportState',
    component: () => import('@/pages/h5/Report/FinancingReport/State/index.vue'),
    meta: { title: '融资企业报告' },
  },
];
